import { render } from "./Insemination.vue?vue&type=template&id=48d8f140"
import script from "./Insemination.vue?vue&type=script&lang=js"
export * from "./Insemination.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__